/* Animated Monthly/Annual pill toggle, shared by the Acodia Watch pricing
   page and the dashboard billing upgrade picker. Uses the app CSS tokens so
   it matches both surfaces. */
export default function IntervalToggle({ interval, onChange, showSavings = true }) {
  const isAnnual = interval === 'annual';
  const btnW = 104;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', flexWrap: 'wrap' }}>
      <div
        role="tablist"
        aria-label="Billing interval"
        style={{
          position: 'relative',
          display: 'inline-flex',
          padding: 4,
          borderRadius: 999,
          background: 'var(--l2)',
          border: '1px solid var(--b1)',
        }}
      >
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: 4,
            bottom: 4,
            left: isAnnual ? btnW + 4 : 4,
            width: btnW,
            borderRadius: 999,
            background: 'var(--a)',
            transition: 'left 240ms cubic-bezier(0.4,0,0.2,1)',
          }}
        />
        {[['monthly', 'Monthly'], ['annual', 'Annual']].map(([val, label]) => {
          const active = interval === val;
          return (
            <button
              key={val}
              type="button"
              role="tab"
              aria-selected={active}
              data-testid={`interval-toggle-${val}`}
              onClick={() => onChange(val)}
              style={{
                position: 'relative',
                zIndex: 1,
                width: btnW,
                height: 34,
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '0.82rem',
                fontWeight: 600,
                color: active ? '#fff' : 'var(--ts)',
                transition: 'color 200ms ease',
              }}
            >
              {label}
            </button>
          );
        })}
      </div>
      {isAnnual && showSavings && (
        <span
          data-testid="annual-savings-badge"
          style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: '0.72rem',
            fontWeight: 600,
            color: 'var(--ok)',
            background: 'rgba(74,222,128,0.10)',
            border: '1px solid rgba(74,222,128,0.25)',
            borderRadius: 6,
            padding: '0.25rem 0.6rem',
            whiteSpace: 'nowrap',
          }}
        >
          Save 17% — 2 months free
        </span>
      )}
    </div>
  );
}
